// extracted by mini-css-extract-plugin
export var marginNegative = "_5i-5 _5i-3 _5i-1";
export var marginPositive = "_5i-4 _5i-3 _5i-1";
export var modalContent = "_5i-6";
export var samplesTable = "_5i-8";
export var samplesTableContainer = "_5i-7";
export var statBox = "_5i-a";
export var tableCell = "_5i-1";
export var tableCellCenter = "_5i-2 _5i-1";
export var tableCellRight = "_5i-3 _5i-1";
export var tableHeader = "_5i-0";
export var trackingNumber = "_5i-9";